const GroupTreatmentFailureIcon = () => {
  return (
    <svg width="77" height="66" viewBox="0 0 77 66" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M37.2119 3.08691C37.7938 2.11166 39.2062 2.11166 39.7881 3.08691L74.7754 61.7314C75.3718 62.7312 74.6514 63.9998 73.4873 64H3.5127C2.34859 63.9998 1.62819 62.7312 2.22461 61.7314L37.2119 3.08691Z" fill="#C43B51" fillOpacity="0.3" stroke="#C43B51" strokeWidth="3"/>
      <path d="M41.6179 24.3C41.6179 22.4775 40.1364 21 38.309 21C36.4815 21 35 22.4775 35 24.3V44.1C35 45.9225 36.4815 47.4 38.309 47.4C40.1364 47.4 41.6179 45.9225 41.6179 44.1V24.3Z" fill="#C43B51"/>
      <path d="M41.6179 53.9992C41.6179 52.1767 40.1364 50.6992 38.309 50.6992C36.4815 50.6992 35 52.1767 35 53.9992C35 55.8218 36.4815 57.2992 38.309 57.2992C40.1364 57.2992 41.6179 55.8218 41.6179 53.9992Z" fill="#C43B51"/>
    </svg>
  )
}

export { GroupTreatmentFailureIcon }
